import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Table, Tooltip } from "antd";
import { Link } from "react-router-dom";
import "antd/dist/antd.css";
import axios from "axios";
import closeIcon from "../../assets/img/profiles/close-circle-fill.svg";
import {
  itemRender,
  onShowSizeChange,
} from "../../components/paginationfunction";
import "../../../src/antdstyle.css";
import Sidebar from "../Sidebar/sidebar";
import Header from "../Sidebar/header";
import ReviewForm from "./ReviewForm";
import Rating from "@mui/material/Rating";
import ques from "../../assets/img/profiles/ques.svg";
import half from "../../assets/img/profiles/half.svg";
import comment from "../../assets/img/profiles/comment.svg";

// Datatable JS
// import "../../../assets/js/jquery.dataTables.min.js";
// import "../../../assets/js/dataTables.bootstrap4.min.js";

const Review = () => {
  const [menu, setMenu] = useState(false);
  const [empReview, setEmpReview] = useState();
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [displayPage, setDisplayPage] = useState("recieved");
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const [data, setData] = useState([]);
  const [reviewData, setReviewData] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/review/`, {
        params: {
          empid: sessionStorage.getItem("emp_id"),
          toggle: "c",
        },
      })
      .then((res) => {
        setData(res.data);
        setData(
          res.data.map((ele, index) => ({
            ...ele,
            sno: index + 1,
          }))
        );
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/review/`, {
        params: {
          empid: sessionStorage.getItem("emp_id"),
          toggle: "b",
        },
      })
      .then((res) => {
        setReviewData(
          res.data.map((ele, index) => ({
            ...ele,
            sno: index + 1,
          }))
        );
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleEmpReview = (e, reviewid, by_empid, to_empid) => {
    e.preventDefault();
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/review/`, {
        params: {
          review_id: reviewid,
          by_empid: by_empid,
          to_empid: to_empid,
          toggle: "e",
        },
      })
      .then((res) => {
        console.log(res.data, "Hello");
        setEmpReview(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const columns = [
    {
      title: "SNo",
      dataIndex: "sno",
    },
    {
      title: "Review Form Name",
      dataIndex: "review_form_name",
      sorter: (a, b) => a.reviewer_name.localeCompare(b.reviewer_name),
    },
    {
      title: "Rating",
      align: "center",
      dataIndex: "avg",
      render: (text, record) => (
        <>
          <Rating
            name="half-rating-read"
            defaultValue={text}
            precision={0.5}
            readOnly
          />
        </>
      ),
    },

    // {
    //   title: "Rating",
    //   align: "center",
    //   dataIndex: "avg",
    //   sorter: (a, b) => a.rating.localeCompare(b.rating),
    //   render: (text, record) => (
    //     <button
    //       className="choose-file-btn"
    //       style={{
    //         background:
    //           text === "Satisfactory"
    //             ? "#FFA500"
    //             : text === "Unsatisfactory"
    //             ? "#FF7676"
    //             : text === "Good"
    //             ? "#68B266"
    //             : "#3298DB",
    //         width:
    //           text === "Satisfactory"
    //             ? "100px"
    //             : text === "Unsatisfactory"
    //             ? "110px"
    //             : text === "Good"
    //             ? "80px"
    //             : text === "Need Improvement"
    //             ? "175px"
    //             : "300px",
    //         fontSize: "14px",
    //       }}
    //     >
    //       {text === 5
    //         ? "Exellence"
    //         : text === 4
    //         ? "Good"
    //         : text === 3
    //         ? "Satisfactory"
    //         : text === 2
    //         ? "Need Improvement"
    //         : "UnSatisfactory"}
    //     </button>
    //   ),
    // },

    {
      title: "Comments",
      dataIndex: "comment",
      // render: (text, record) => <span>$ {text}</span>,
      sorter: (a, b) => a.comment.length - b.comment.length,
      ellipsis: {
        showTitle: false,
      },
      render: (comment) => (
        <Tooltip placement="topLeft" title={comment}>
          {comment}
        </Tooltip>
      ),
    },
    {
      title: "Action",
      align: "center",
      render: (text, record) => (
        <button
          className="choose-file-btn"
          style={{
            background: "#68B266",
            width: "80px",

            fontSize: "14px",
          }}
          onClick={(e) =>
            handleEmpReview(e, text.review_id, text.by_emp, text.to_emp)
          }
          data-bs-toggle="modal"
          data-bs-target="#show_review"
        >
          view
        </button>
      ),
    },
  ];

  const column1 = [
    {
      title: "SNo",
      dataIndex: "sno",
      // width: 100,
    },
    {
      title: "Reviewer Employee",
      dataIndex: "by_emp_name",
      sorter: (a, b) => a.reviewer_name.localeCompare(b.reviewer_name),
    },

    {
      title: "Reviewed Name",
      dataIndex: "to_emp_name",
      sorter: (a, b) => a.department.localeCompare(b.department),
    },
    {
      title: "Rating",
      align: "center",
      dataIndex: "avg",
      render: (text, record) => (
        <>
          <Rating
            name="half-rating-read"
            defaultValue={text}
            precision={0.5}
            readOnly
          />
        </>
      ),
    },

    // {
    //   title: "Rating",
    //   align: "center",
    //   dataIndex: "avg",
    //   sorter: (a, b) => a.rating.localeCompare(b.rating),
    //   render: (text, record) => (
    //     <button
    //       className="choose-file-btn"
    //       style={{
    //         background:
    //           text === 3
    //             ? "#FFA500"
    //             : text === 5
    //             ? "#FF7676"
    //             : text === 4
    //             ? "#68B266"
    //             : "#3298DB",
    //         width:
    //           text === 3
    //             ? "100px"
    //             : text === 5
    //             ? "110px"
    //             : text === 4
    //             ? "80px"
    //             : text === 2
    //             ? "175px"
    //             : "300px",
    //         fontSize: "14px",
    //       }}
    //     >
    //       {text === 5
    //         ? "Exellence"
    //         : text === 4
    //         ? "Good"
    //         : text === 3
    //         ? "Satisfactory"
    //         : text === 2
    //         ? "Need Improvement"
    //         : "UnSatisfactory"}
    //     </button>
    //   ),
    // },

    {
      title: "Comments",
      dataIndex: "comment",
      // render: (text, record) => <span>$ {text}</span>,
      sorter: (a, b) => a.Comments.length - b.Comments.length,
      ellipsis: {
        showTitle: false,
      },
      render: (comment) => (
        <Tooltip placement="topLeft" title={comment}>
          {comment}
        </Tooltip>
      ),
    },
    {
      title: "Action",
      align: "center",
      render: (text, record) => (
        <button
          className="choose-file-btn"
          style={{
            background: "#68B266",
            width: "80px",

            fontSize: "14px",
          }}
          onClick={(e) =>
            handleEmpReview(e, text.review_id, text.by_emp, text.to_emp)
          }
          data-bs-toggle="modal"
          data-bs-target="#show_review"
        >
          view
        </button>
      ),
    },
  ];

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={(value) => toggleMobileMenu()} />

      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">Performance Review</h3>
              </div>
              <div className="col-auto float-end ml-auto">
                <div className="view-icons" style={{ marginBottom: "-15px" }}>
                  <button
                    className="btn btn-success btn-block "
                    style={{
                      padding: "6px 15px",
                      fontSize: "15px",
                      background:
                        displayPage === "recieved" ? " #151147" : "#FFFFFF",
                      border: "none",
                      color: displayPage === "recieved" ? "#FFFFFF" : "#344767",
                    }}
                    // data-bs-toggle="modal"
                    // data-bs-target="#personal_info_modal"
                    onClick={() => {
                      setDisplayPage("recieved");
                    }}
                  >
                    {" "}
                    Reviews Received
                  </button>

                  <button
                    className="btn btn-success btn-block "
                    style={{
                      padding: "6px 15px",
                      fontSize: "15px",
                      background:
                        displayPage === "submitted" ? " #151147" : "#FFFFFF",
                      border: "none",
                      color:
                        displayPage === "submitted" ? "#FFFFFF" : "#344767",
                    }}
                    // data-bs-toggle="modal"
                    // data-bs-target="#personal_info_modal"
                    onClick={() => {
                      setDisplayPage("submitted");
                    }}
                  >
                    Previous Reviews Submitted
                  </button>

                  <button
                    className="btn btn-success btn-block "
                    style={{
                      padding: "6px 15px",
                      fontSize: "15px",
                      background:
                        displayPage === "form" ? " #151147" : "#FFFFFF",
                      border: "none",
                      color: displayPage === "form" ? "#FFFFFF" : "#344767",
                    }}
                    // data-bs-toggle="modal"
                    // data-bs-target="#personal_info_modal"
                    // onClick={() => setApplyLeave("regular")}
                    onClick={() => {
                      setDisplayPage("form");
                    }}
                  >
                    Review Employee
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {displayPage === "form" && (
            <ReviewForm setDisplayPage={setDisplayPage} />
          )}
          {displayPage === "recieved" && (
            <div className="row">
              <div className="col-sm-12">
                <div className="card mb-0">
                  <div className="card-body">
                    <div className="table-responsive">
                      <h4>Review Recieved from Employee</h4>
                      <Table
                        className="table-striped"
                        ellipsis={true}
                        pagination={{
                          total: reviewData.length,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          showSizeChanger: true,
                          onShowSizeChange: onShowSizeChange,
                          itemRender: itemRender,
                        }}
                        style={{ overflowX: "auto" }}
                        columns={columns}
                        // bordered
                        dataSource={reviewData}
                        rowKey={(record) => record.id}
                        // onChange={this.handleTableChange}
                        loading={loading}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {displayPage === "submitted" && (
            <div className="row">
              <div className="col-sm-12">
                <div className="card mb-0">
                  <div className="card-body">
                    <div className="table-responsive">
                      <h4>Previous Reviews Submitted</h4>
                      <Table
                        ellipsis={true}
                        pagination={{
                          total: data.length,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          showSizeChanger: true,
                          onShowSizeChange: onShowSizeChange,
                          itemRender: itemRender,
                        }}
                        style={{ overflowX: "auto" }}
                        columns={column1}
                        bordered
                        dataSource={data}
                        rowKey={(record) => record.id}
                        // onChange={this.handleTableChange}
                        loading={isLoading}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div
            id="show_review"
            className="modal custom-modal fade"
            role="dialog"
          >
            <div
              className="modal-dialog modal-dialog-centered modal-lg"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <br />
                  <br />
                  <br />
                  <h5 className="modal-title">
                    <b>Review</b>
                  </h5>
                  <button
                    type="button"
                    className="close-btn"
                    data-bs-dismiss="modal"
                  >
                    <img src={closeIcon} />
                  </button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          {empReview?.map((ele) => {
                            return (
                              <div
                                className="col-sm-12"
                                style={{
                                  border: ".3px solid #5F6368",
                                  borderRadius: "5px",
                                  marginBottom: "10px",
                                  padding: "15px",
                                }}
                              >
                                <div className="col-sm-12">
                                  <p
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span>
                                      <img src={ques} />
                                    </span>{" "}
                                    &nbsp;&nbsp;
                                    <span style={{ fontWeight: "600" }}>
                                      {ele.question}
                                    </span>
                                  </p>
                                  <hr
                                    style={{
                                      boxSizing: "border-box",
                                      height: "2px",
                                      marginTop: "-8px",
                                      paddingX: "5px",
                                    }}
                                  />
                                </div>

                                <div className="row col-sm-12">
                                  <div className="col-sm-3">
                                    <p
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <span>
                                        <img src={half} />
                                      </span>{" "}
                                      &nbsp;&nbsp;&nbsp;
                                      <span
                                        style={{
                                          fontWeight: "600",
                                          marginTop: "4px",
                                        }}
                                      >
                                        Rating :
                                      </span>
                                    </p>
                                  </div>

                                  <div className="col-sm-9">
                                    <Rating
                                      name="half-rating-read"
                                      defaultValue={ele.rating}
                                      precision={0.5}
                                      readOnly
                                    />
                                  </div>
                                </div>
                                <div className="row col-sm-12">
                                  <div className="col-sm-3">
                                    <p
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <span>
                                        <img src={comment} />
                                      </span>{" "}
                                      &nbsp;&nbsp;&nbsp;
                                      <span
                                        style={{
                                          fontWeight: "600",
                                          marginTop: "4px",
                                        }}
                                      >
                                        Comment :
                                      </span>
                                    </p>
                                  </div>

                                  <div className="col-sm-9">
                                    <p>
                                      {ele.comment?.length > 0 ? (
                                        ele.comment
                                      ) : (
                                        <i>No Comment</i>
                                      )}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Review;
